<template>
  <div class="match-detail">
    <div class="wdd">
      <div style="background: #fff;" v-if="contestInfo.contentType==1">
        <img :src="contestInfo.bannerUrl"
             alt="">
        <div class="btn">
          <span @click="toApply()">立即参加</span>
        </div>
        <img :src="contestInfo.processUrl"
             alt="">
        <div class="btn"
             v-if="contestInfo.guideUrl">
          <span><a :href="contestInfo.guideUrl"
               target="_blank">下载参赛指南 </a></span>
        </div>
        <img :src="contestInfo.contentUrl"
             alt="">
      </div>
      <div v-if="contestInfo.contentType==2" v-html="contestInfo.html" style="overflow:hidden;">

      </div>
    </div>
    <div class="btn">
      <Button><a :href="'/static/scratch3/index.html?scene=contest&contestId=' + contestId"
           style="color: #f36!important;"
           target="_blank">立即创作</a></Button>
      <span @click="toApply()">立即参加</span>
      <Button v-if="false"
              @click="isShowUploadWork = true">立即上传作品</Button>
    </div>
    <!-- <Modal v-model="isShowUpload"
           class-name="vertical-center-modal"
           okText="点击下载"
           @on-ok="sure"
           class="upload-modal">
      <div class="upload-content">
        <div>
          <span>文件名：</span>
          <svg-icon icon-class="file"></svg-icon>
          <span>比赛规则.pdf</span>
        </div>
        <div>
          <span>下载到：</span>
          <svg-icon icon-class="pdf"></svg-icon>
          <span>D:\</span>
        </div>
      </div>
    </Modal> -->
    <Modal v-model="isShowApply"
           class-name="vertical-center-modal"
           okText="确认报名"
           @on-ok="applyContest"
           class="login-modal"
           width="800">
      <div class="login-content">
        <Row type="flex"
             justify="space-between">
          <i-col span="11">
            <Form :model="formItem"
                  :label-width="80"
                  style="padding-top: 40px">
              <FormItem label="学生姓名">
                <i-input v-model="formItem.studentName"
                         placeholder="请输入学生姓名"></i-input>
              </FormItem>
              <FormItem label="指导老师">
                <i-input v-model="formItem.instructor"
                         placeholder="请输入指导老师"></i-input>
              </FormItem>
              <FormItem label="联系电话">
                <i-input v-model="formItem.phone"
                         placeholder="请输入联系电话"></i-input>
              </FormItem>
            </Form>
          </i-col>
          <i-col span="10"
                 class="wx">
            <img src="@/assets/common/logo.png"
                 alt="">
            <p style="color: #02A7F0; margin-left: 40px">微信扫一扫快速报名</p>
          </i-col>
        </Row>
      </div>
    </Modal>
    <Modal v-model="isShowUploadWork"
           class-name="vertical-center-modal"
           okText="开始上传"
           @on-ok="upload"
           class="work-modal"
           width="800">
      <div class="work-content">
        <Row>
          <i-col span="3">
            <span class="status-title">手动上传：</span>
          </i-col>
          <i-col span="20">
            <Upload multiple
                    :accept="Accept"
                    :before-upload="handleUpload"
                    action="//jsonplaceholder.typicode.com/posts/">
              <Button icon="ios-cloud-upload-outline"
                      :disabled="uploadSuccess">选择文件</Button>
            </Upload>
            <p>支持文件格式：.rar .zip .doc .docx .pdf ，单个文件不能超过10M</p>
          </i-col>
        </Row>
      </div>
      <div class="work-status">
        <Row v-show="fileList.length > 0">
          <i-col span="3">
            <span class="status-title">上传状态：</span>
          </i-col>
          <i-col span="20">
            <div class="file-item"
                 v-for="(item, index) in fileList"
                 :key="index">
              <span>{{ item.name }} </span>
              <span class="text"
                    @click="cancleFile(index)"
                    v-show="!uploadSuccess">取消</span>
              <span class="success"
                    v-show="uploadSuccess">上传成功</span>
            </div>
          </i-col>
        </Row>
      </div>
      <div slot="footer"
           class="work-footer">
        <Button v-show="fileList.length > 0 && !uploadSuccess"
                @click="upload"
                :loading="loadingStatus">{{ loadingStatus ? '上传中' : '开始上传' }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { saveContestApply, contestDetail } from "@/api/contest"
import { getUserInfo } from "@/utils/auth";
export default {
  data () {
    return {
      userInfo: null,
      contestId: '',
      isShowUpload: false,
      isShowApply: false,
      isShowUploadWork: false,
      formItem: {},
      fileList: [],
      loadingStatus: false,
      uploadSuccess: false,
      contestInfo: {},
      // .rar .zip .doc .docx .pdf
      Accept: ".pdf,.doc,.docx,.zip,.rar" //上传文件格式限制
    }
  },
  created () {
    this.contestId = this.$route.query.contestId
    this.getContestInfo()
    this.userInfo = JSON.parse(getUserInfo());
  },
  methods: {
    getContestInfo () {
      contestDetail(this.contestId).then(res => {
        if (res.success) {
          this.contestInfo = res.result
        }
      })
    },
    handleUpload (file) {
      if (this.uploadSuccess) {
        this.$Message.warning('已上传成功')
        return false
      };
      let l10M = 10 * 1024 * 1024;
      if (file.size > l10M) {
        this.$Message.warning('单个文件不能超过10M')
        return false
      }
      this.fileList.push(file);
      return false;
    },
    upload () {
      if (this.loadingStatus) return;
      this.loadingStatus = true;
      setTimeout(() => {
        // this.fileList = [];
        this.loadingStatus = false;
        this.$Message.success('上传成功')
        this.uploadSuccess = true
      }, 1500);
    },
    applyContest () {
      if (this.formItem.studentName && this.formItem.instructor && this.formItem.phone) {
        saveContestApply(this.contestId, this.formItem.studentName, this.formItem.instructor, this.formItem.phone).then(res => {
          if (res.success) {
            this.$Message.success(res.message)
          }
        })
      } else {
        this.$Message.success("请填写完整信息")
        return false;
      }
    },
    cancleFile (index) {
      this.fileList.splice(index, 1);
    },
    toApply(){
      if(this.userInfo == null){
        window.location.href = "/login"
      }else{
        this.isShowApply = true
      }
    }
  }
}
</script>
<style lang="scss">
.upload-modal {
  // .ivu-modal-body {
  //   background: rgba(0, 0, 0, 0.1);
  // }
  .upload-content {
    background: #fff;
    width: 280px;
    margin: 66px auto;
    font-size: 20px;
    padding: 0 10px;
    div {
      margin-top: 20px;
      svg {
        margin: 0 10px;
      }
    }
  }
}
.login-modal {
  .ivu-modal-body {
    padding: 30px;
  }
  .login-content {
    .wx {
      img {
        width: 194px;
      }
    }
  }
}
.work-modal {
  .ivu-modal-content {
    border-radius: 10px;
  }
  .ivu-modal-body {
    padding: 0;
  }
  .ivu-modal-close .ivu-icon {
    font-weight: 700;
    color: #fff;
  }
  .ivu-modal-footer {
    background: rgba(0, 255, 204, 1);
    border: none;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .work-content {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 98px;
    background-color: rgba(0, 204, 204, 1);
    padding: 30px;
  }
  .status-title {
    font-weight: 700;
  }
  .work-status {
    padding: 30px;
    background: rgba(0, 255, 204, 1);
    min-height: 200px;
    .file-item {
      margin-bottom: 15px;
      .text {
        margin-left: 20px;
        font-size: 12px;
        color: #0079fe;
        cursor: pointer;
      }
      .success {
        margin-left: 20px;
        font-size: 12px;
      }
    }
  }
  .work-footer {
    background: rgba(0, 255, 204, 1);
  }
}
</style>
<style lang="scss" scoped>
.match-detail {
  margin-top: -80px;
  padding-top: 80px;
  background: linear-gradient(36deg, #6f86d6 7%, #4dbceb 100%) no-repeat;
  background-size: 100% 80px;
  .wdd {
    width: 1100px;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }
  .btn {
    text-align: center;
    margin: 50px 0;
    span {
      display: inline-block;
      color: #fff;
      border-radius: 20px;
      background: rgba(255, 51, 102, 1);
      width: 160px;
      height: 50px;
      font-weight: 700;
      font-size: 20px;
      line-height: 50px;
      margin: 0 40px;
    }
    button {
      color: rgba(255, 51, 102, 1);
      width: 160px;
      height: 50px;
      font-weight: 700;
      font-size: 20px;
      line-height: 50px;
      border: 1px solid rgba(255, 51, 102, 1);
      border-radius: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/matchDetail.vue